export default __webpack_public_path__ + "static/media/12.8491e637.pdf";